var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_c('trigger-item',{attrs:{"item":item},on:{"del-item":_vm.deleteItem}})],1)}),_c('button',[_vm._v(" Add trigger ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }